import List from "@mui/material/List";
import { useSelector } from "react-redux";
import constants from "../common/constants";
import { AppBar } from "@mui/material";
import SideBar from "rc-material-sidebar";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

const AdminSidebar = ({ open }) => {
  const { userData } = useSelector((state) => state.mainReducer);
  const { ADMIN, USER } = constants;
  const onClick = (e, item) => {
    // console.log(e, item);
  };

  // console.log("AdminSidebar userData:", userData?.role);
  const allItems = [
    {
      key: "1",
      label: "Dashboard",
      link: "/app",
      icon: <DashboardRoundedIcon sx={{ width: "34px" }} />,
      roles: [ADMIN, USER],
    },
    {
      key: "2",
      label: "Users",
      link: "/app/users",
      icon: <PeopleAltRoundedIcon sx={{ width: "34px" }} />,
      roles: [ADMIN],
    },
    {
      key: "3",
      label: "Resource",
      link: "/app/user-only",
      icon: <DescriptionRoundedIcon sx={{ width: "34px" }} />,
      roles: [USER],
    },
  ];

  const filteredItems = allItems.filter((item) =>
    item.roles.includes(userData?.role),
  );

  return (
    <AppBar
      position="fixed"
      component="div"
      color="transparent"
      elevation={0}
      sx={{
        width: open ? 240 : 66,
        right: "inherit",
        height: "calc(100% - 64px)",
        top: 64,
        bgcolor: "#050530",
        "& .MuiListItemText-root span": { color: "rgba(255,255,255,0.75)" },
        "& .MuiListItemIcon-root": { color: "rgba(255,255,255,0.6)" },
        "& .MuiListItemButton-root:hover": { bgcolor: "rgba(255,255,255,0.06)" },
      }}
    >
      <List className="sidebarMenu">
        <SideBar
          items={filteredItems}
          variant={open ? "full" : "mini"}
          onClick={onClick}
        />
      </List>
    </AppBar>
  );
};

export default AdminSidebar;
